export const UPDATE_POST = "UPDATE_POST";
export const AUTHENTICATION = "AUTHENTICATION";
export const SET_LOADING_STATE = "SET_LOADING_STATE";

// Loading Indicators
export const ADS_LOADING = "ADS_LOADING";
export const AD_LOADING = "AD_LOADING";
